// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"095ad817","67":"c37aa3f5","171":"eb7fd4ac","212":"1b311eb1","365":"2a1940d2","499":"17e08bef","537":"d670361b","546":"8f0ef3b6","751":"eab2aab5"}[chunkId] + ".chunk.js";
};